import React, { lazy } from 'react';
import Loadable from '../../components/Loadable';
import { RiderProvider } from "../../contexts/riderContext/RiderContext";
import ServiceArea from '../service-areas/ServiceArea';
import ImageProcessReport from './detail/ImageProcessReport';
import RiderTransectionReport from './detail/RiderTransectionReport';
import SellerTransectionReport from './detail/SellerTransectionReport';

const RiderFragment = Loadable(lazy(() => import('./views/RiderFragment')));
const RiderDetailFragmentV2 = Loadable(lazy(() => import('./pages/riders/rider/Rider')));
const RiderPaymentReceiveFragmentV2 = Loadable(lazy(() => import('./pages/riders/rider/PaymentReceive')));

const LiveRiders = Loadable(lazy(() => import('./views/LiveRiders')));
const RiderDetailFragment = Loadable(lazy(() => import('./detail/RiderDetailFragment')));
const Reports = Loadable(lazy(() => import('./detail/Reports')));
const DailySalesReport = Loadable(lazy(() => import('./detail/DailySalesReport')));
const ContentTeamReport = Loadable(lazy(() => import('./detail/ContentTeamReport')));

const riderRoutes = [
    { path: '/riders', element: <RiderProvider><RiderFragment /></RiderProvider> },
    { path: '/riders/:id', element: <RiderProvider><RiderDetailFragmentV2 /></RiderProvider> },
    { path: '/rider-payment-receive/:id', element: <RiderProvider><RiderPaymentReceiveFragmentV2 /></RiderProvider> },
    { path: '/live_rider', element: <RiderProvider><LiveRiders /></RiderProvider> },
    { path: '/rider_detail/:id', element: <RiderProvider><RiderDetailFragment /></RiderProvider> },
    { path: '/add_rider', element: <RiderProvider><RiderFragment /></RiderProvider> },
    { path: '/add_rider/:id', element: <RiderProvider><RiderFragment /></RiderProvider> },
    { path: '/service-areas', element: <><ServiceArea /></> },
    { path: '/reports', element: <><Reports /></> },
    { path: '/reports/daily-sales-report', element: <><DailySalesReport /></> },
    { path: '/reports/content-team-report', element: <><ContentTeamReport /></> },
    { path: '/reports/content-image-process-report', element: <><ImageProcessReport /></> },
    { path: '/reports/seller-transections-process-report', element: <><SellerTransectionReport /></> },
    { path: '/reports/rider-transections-process-report', element: <><RiderTransectionReport /></> }
];

export default riderRoutes;
